// Vendor avatar — initial letter circle, never colored.
// Mirrors gastos-v2/primitives.jsx VendorAvatar.
'use client';

function initialOf(name: string | null | undefined): string {
  if (!name) return '?';
  const cleaned = name.replace(/[^A-Za-zÀ-ÿ]/g, '');
  return (cleaned.charAt(0) || '?').toUpperCase();
}

export function VendorAvatar({
  name,
  size = 22,
}: {
  name: string | null | undefined;
  size?: number;
}) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        fontFamily: 'var(--font-sans)',
        fontSize: '11px',
        fontWeight: 500,
        color: 'var(--ink-2)',
        background: 'var(--surface-2)',
        border: '1px solid var(--hairline)',
        flexShrink: 0,
      }}
      aria-hidden="true"
    >
      {initialOf(name)}
    </span>
  );
}
